export default function getPolygonExtremeties(polygon: TPolygonOrAmalgam): TPolygonExtremeties {
	const { coords } = polygon;
	return {
		minX: coords.reduce((prev, curr) => Math.min(curr[0], prev), 99999),
		minY: coords.reduce((prev, curr) => Math.min(curr[1], prev), 99999),
		maxX: coords.reduce((prev, curr) => Math.max(curr[0], prev), 0),
		maxY: coords.reduce((prev, curr) => Math.max(curr[1], prev), 0),
	};
}
